/*
 * The texts of the context extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	pages: {
		admin: {
			settings: {
				context_roles_and_permissions: {
					context_roles: 'Context Rollen',
					context_permissions: 'Context Berechtigungen',
				},
			},
		},
		context: {
			users: {
				title: 'Personen',
			},
		},
	},
	components: {
		user_memberships: {
			title: 'Mitgliedschaften',
		},
	},
	modals: {
		add_user: {
			title: 'Person hinzufügen',
			input: 'Person auswählen',
		},
		invite_user: {
			title: 'Person einladen oder hinzufügen',
			input: 'Suche nach Name oder Mail-Adresse',
			context_role: 'Rolle',
		},
	},
	data: {
		context_role: {
			id: 'Id',
			name: 'Name',
			guard_name: 'Guard',
			context_model_type: 'Context Model',
			description: 'Beschreibung',
			context_permissions: 'Berechtigungen',
		},
		context_permission: {
			id: 'Id',
			name: 'Name',
			guard_name: 'Guard',
			context_model_type: 'Context Model',
			description: 'Beschreibung',
		},
	},
	confirms: {
		remove_context_user: {
			title: 'Person entfernen',
			text: 'Soll {name} aus \'{context}\' entfernt werden?',
		},
	},
	tabs: {
		context_settings: {
			members: 'Mitglieder',
		},
		admin_settings: {
			context_roles_and_permissions: 'Context-Rollen & -Berechtigungen',
		},
	},
};
